import styled from 'styled-components'

export const Container = styled.div`
  .menu-user {
    width: 500px;
    ul {
      li {
        font-size: 25px;
      }
    }
  }
`
